import { render, staticRenderFns } from "./goods_price_edit.vue?vue&type=template&id=ab292bc6&"
import script from "./goods_price_edit.vue?vue&type=script&lang=js&"
export * from "./goods_price_edit.vue?vue&type=script&lang=js&"
import style0 from "./goods_price_edit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports